import React from 'react';
import { Trans } from 'react-i18next';
import PeriodTableCellComponent from './period-table-cell.component';
import { EPeriodTableColumns, EPeriodTableCellEnum } from './period-table.enum';
import { ColumnsType, TPeriodLimitsTableRecord } from './period-table.types';

type TOnCellClickHandler = (record: TPeriodLimitsTableRecord, cellId: string[]) => void;

const columns = (
  onCellClickHandler: TOnCellClickHandler,
): ColumnsType<TPeriodLimitsTableRecord> => ([
  {
    title: <Trans i18nKey="limits.standardLimits.table.period.column.title.currency" />,
    dataIndex: EPeriodTableColumns.AsseCode,
    width: 205,
  },
  {
    title: <Trans i18nKey="limits.standardLimits.table.period.column.title.period" />,
    dataIndex: EPeriodTableColumns.Period,
    width: 1170,
    children: [
      {
        title: <Trans i18nKey="limits.standardLimits.table.period.column.title.day" />,
        dataIndex: [EPeriodTableColumns.Period, EPeriodTableColumns.Day, EPeriodTableColumns.Max],
        width: 219,
        render: (value: string) => <PeriodTableCellComponent type={EPeriodTableCellEnum.Max}>
          {value}
        </PeriodTableCellComponent>,
        onCell: (record: TPeriodLimitsTableRecord) => ({
          onClick: (): void => {
            onCellClickHandler(record, [EPeriodTableColumns.Period, EPeriodTableColumns.Day]);
          },
        }),
      },
      {
        title: <Trans i18nKey="limits.standardLimits.table.period.column.title.week" />,
        dataIndex: [EPeriodTableColumns.Period, EPeriodTableColumns.Week, EPeriodTableColumns.Max],
        width: 216,
        render: (value: string) => <PeriodTableCellComponent type={EPeriodTableCellEnum.Max}>
          {value}
        </PeriodTableCellComponent>,
        onCell: (record: TPeriodLimitsTableRecord) => ({
          onClick: () => onCellClickHandler(record, [EPeriodTableColumns.Period, EPeriodTableColumns.Week]),
        }),
      },
      {
        title: <Trans i18nKey="limits.standardLimits.table.period.column.title.month" />,
        dataIndex: [EPeriodTableColumns.Period, EPeriodTableColumns.Month, EPeriodTableColumns.Max],
        width: 217,
        render: (value: string) => <PeriodTableCellComponent type={EPeriodTableCellEnum.Max}>
          {value}
        </PeriodTableCellComponent>,
        onCell: (record: TPeriodLimitsTableRecord) => ({
          onClick: () => onCellClickHandler(record, [EPeriodTableColumns.Period, EPeriodTableColumns.Month]),
        }),
      },
      {
        title: <Trans i18nKey="limits.standardLimits.table.period.column.title.year" />,
        dataIndex: [EPeriodTableColumns.Period, EPeriodTableColumns.Year, EPeriodTableColumns.Max],
        width: 216,
        render: (value: string) => <PeriodTableCellComponent type={EPeriodTableCellEnum.Max}>
          {value}
        </PeriodTableCellComponent>,
        onCell: (record: TPeriodLimitsTableRecord) => ({
          onClick: () => onCellClickHandler(record, [EPeriodTableColumns.Period, EPeriodTableColumns.Year]),
        }),
      },
      {
        title: <Trans i18nKey="limits.standardLimits.table.period.column.title.days" />,
        dataIndex: [EPeriodTableColumns.Period, EPeriodTableColumns.Days, EPeriodTableColumns.Max],
        width: 301,
        render: (value: string, record: TPeriodLimitsTableRecord) => <PeriodTableCellComponent
          type={EPeriodTableCellEnum.CustomDays}
        >
          {record.period.days.period_key === null || value === null ? null : (
            <>
              <div>
                {record.period.days.period_key}&nbsp;
                <Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.days" />
              </div>
              <div>{value}</div>
            </>
          )}
        </PeriodTableCellComponent>,
        onCell: (record: TPeriodLimitsTableRecord) => ({
          onClick: () => onCellClickHandler(record, [EPeriodTableColumns.Period, EPeriodTableColumns.Days]),
        }),
      },
    ],
  }
]);

export default columns;
